/*
 * @Author: liyxt
 * @Date: 2020-05-06 14:00:41
 * @LastEditors: bbqin
 * @LastEditTime: 2022-07-26 15:48:45
 * @Description: file content
 */
import React, { Component } from 'react';
//import OriginTree from 'bee-tree';
import { Tree as OriginTree } from '@tinper/next-ui';
import SvgIcon from '../SvgIcon';

import classNames from 'classnames';
import hotkeys from './hotkeys';

require('./index.less');

const TreeNode = OriginTree.TreeNode;
@hotkeys(true)
class Tree extends Component {
    render() {
        let { 
            openIcon,
            closeIcon, 
            className,
            debounceDuration = 10,
            syncCheckedAndSelectedStatus = false, 
            showIcon = true,
            hideTreeIcon = false,
            inverse = true,
            ...others
        } = this.props;
        return <OriginTree
            openIcon={
                typeof openIcon === "function" && (
                    openIcon() //默认显示tinper的开合icon
                )
            }
            closeIcon={
                typeof closeIcon === "function" && (
                    closeIcon()
                )
            }
            getCheckboxAttrs={() => {
                return { fieldid: 'tree-checkbox', treeCheckboxTarget: 'default-target' };
            }}
            debounceDuration={debounceDuration}
            syncCheckedAndSelectedStatus={syncCheckedAndSelectedStatus}
            showIcon={showIcon}
            inverse={inverse}
            icon={({ expanded, isleaf, isLeaf, children })=>{
                let floadIcon = null;
                if(hideTreeIcon){
                    return floadIcon;
                }
                if (isleaf === false || isLeaf === false || (Array.isArray(children) && children.length != 0)) {
                    floadIcon = expanded ? (
                        // <i
                        //     className={'icon iconfont  icon-wenjianjiadakai tree-wenjian'}
                        // />
                        <SvgIcon type="kaiqi" />
                    ) : (
                    // <i
                    //     className={'icon iconfont  icon-wenjianjia tree-wenjian'}
                    // />
                        <SvgIcon type="guanbi" />
                    );
                } else {
                    floadIcon = (
                        <i
                            className={'tree-dian'}
                        />
                    );
                }
                return floadIcon;
            }}
            {...others}
            className={classNames('base-tree', className)}
        />;
    }
}
Tree.TreeNode = TreeNode;
export default Tree;
